import { AutomationListId, ButtonIdModel, CardIdModel, IdModelBase } from "@q4/nimbus-ui";
import type { Key } from "react";
import { FilingJob } from "../../data/jobs/jobs.definition";

export type FilingJobProps = FilingJob;

export enum FilingJobClassName {
  Base = "filing-job",
  BaseWidthDisabledModifier = "filing-job--disabled",
  Icon = "filing-job_icon",
}

export class FilingJobIdModel extends IdModelBase {
  card: CardIdModel;
  go: ButtonIdModel;

  constructor(id: string, index?: Key, postfix?: string) {
    super(id, index, postfix);

    this.card = new CardIdModel(`${this.id}Card`);
    this.go = new ButtonIdModel(`${this.id}GoButton`);
  }
}

export class FilingJobListId extends AutomationListId<FilingJobIdModel> {
  constructor(parentId: string, prefix = "", postfix = "Job") {
    super(parentId, prefix, FilingJobIdModel, postfix);
  }
}
